import "./src/styles/main.css"

import { MenuHamburger } from './src/components/MenuHamburger'
import { Section } from './src/components/Section';
import { SliderPortfolio } from './src/components/SliderPortfolio';
import { SliderProjects } from './src/components/SliderProjects';
import { SliderSkills } from './src/components/SliderSkills';
import { FormContact } from './src/components/FormContact'

window.addEventListener('DOMContentLoaded', () => {
	Section.init()
	MenuHamburger.init()
	SliderProjects.init()
	SliderSkills.init()
	SliderPortfolio.init()
	FormContact.init()

	const scene = document.getElementById('scene');
	new Parallax(scene);
})

